import { render, staticRenderFns } from "./DemoWatermark.vue?vue&type=template&id=05cc8d68&"
var script = {}
import style0 from "./DemoWatermark.vue?vue&type=style&index=0&id=05cc8d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports